import { ReactNode } from 'react';
import PageTab from './page-tab';
import PageTabs from './page-tabs';
import { PageContainer } from 'src/components/molecules/page-container';
import PageHeader from './page-header';
import PageBackButton from './page-back-button';
import PageContextProvider from 'src/contexts/page-context';
import PageContentContainer from './page-content-container';

interface Props {
  children: ReactNode;
}

const Page = ({ children }: Props) => {
  return (
    <PageContextProvider>
      <PageContainer>{children}</PageContainer>
    </PageContextProvider>
  );
};

export default Page;

Page.Header = PageHeader;
Page.Tabs = PageTabs;
Page.Tab = PageTab;
Page.ContentContainer = PageContentContainer;
Page.BackButton = PageBackButton;
